/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
var Directions;
(function (Directions) {
    Directions["rightToLeft"] = "rtl";
    Directions["leftToRight"] = "ltr";
    /**
     * Alias for rightToLeft
     */
    Directions["rtl"] = "rtl";
    /**
     * Alias for leftToRight
     */
    Directions["ltr"] = "ltr";
})(Directions || (Directions = {}));
export default Directions;
